import link from "@/scripts/host.js";
import loggedIn from '@/scripts/logged.js';
import handleError from '@/scripts/handleError.js'



export default {
  name: "EditProfile",
  props: ["close"],
 
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      repeatPassword: '',
      newEmail: '',
      repeatEmail: '',
      invalid: false,
      showErrorInfo: null,
      content: 'profile',
      refreshNotes: false,
      currentEmail: (sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).email) || (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).email)

    };
  },
  computed:{
    isLogged(){
      return this.$store.state.loggedIn;
    },
    searchActive() {
      return this.$store.state.searchActive;
    },
    username() {
      return (sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).login) || (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).login)

      
      
    },
    shortUsername() {
      return (sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).loginlength > 8 ? JSON.parse(sessionStorage.getItem('user')).login.slice(0,8) + '...' : JSON.parse(sessionStorage.getItem('user')).login) 
      || (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).login.length > 8 ? JSON.parse(localStorage.getItem('user')).login.slice(0,8) + '...' : JSON.parse(localStorage.getItem('user')).login)

      
    },
    email() {
      return (sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).email) || (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).email)
  },
  },
  methods: {
    closeModal() {
      this.$store.dispatch("toggleLoginModal");
    },
    checkPassword() {
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
      return re.test(this.newPassword);
    },
    async logOut() {
      this.showTooltip = false;
      this.closeModal();
      let token = await loggedIn();

      this.axios({
        method: "post",
        url: `${link.hostLink}Account/Logout`,
        headers: {authorization: `bearer ${token}`}
      })
        .then(function() {
          localStorage.removeItem('user');
          sessionStorage.removeItem('user');
        }).catch(function() {
          localStorage.removeItem('user');
          sessionStorage.removeItem('user');
        });
        this.$store.dispatch('setLogInFlag', false);
    },
    confirmChanges() {
      if (this.content == "passChange") {
      this.changePassword()
      } else if (this.content == "profile") {
        this.changeEmail()
      }
    },
    refresh() {
      this.refreshNotes = !this.refreshNotes;
    },
    async changePassword() {
      if(this.newPassword === this.repeatPassword ){
        if(this.checkPassword()){
          this.showErrorInfo = null;
          let token = await loggedIn();

          this.axios({
            method: 'post',
            url: `${link.hostLink}Account/ChangePassword`,
            headers: {authorization: `bearer ${token}`},

            data: {'oldPassword':this.oldPassword, 'newPassword':this.newPassword},
            })
            .then(() => {
              this.invalid = false;

                this.$store.dispatch('setGenericModalText', 'Hasło zostało pomyślnie zmienione.');

                this.$store.dispatch('setModalType', 'genericModal');
            })
            .catch((error)=> {
              this.showErrorInfo=error.response.data.exception;
            });
        } else {
          this.invalid = true;

          this.showErrorInfo = "Hasło musi zawierać minimum 6 znaków, w tym min. 1 dużą literę i 1 cyfrę.";
        }
      } else {
        this.invalid = true;

        this.showErrorInfo = "Nowe hasło nie jest takie samo w obu przypadkach";
      }
    },
    checkEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    async changeEmail() {

      let token = await loggedIn();

      if (
        !this.checkEmail(this.newEmail) ||
        !this.checkEmail(this.repeatEmail) ||
        this.newEmail !== this.repeatEmail
      ) {
        this.invalid = true;
        this.showErrorInfo = 'Podane adresy e-mail nie zgadzają się.'
      } else {
        this.axios({
          method: "post",
          url: `${link.hostLink}Account/Update`,
          data: { email: this.newEmail },
          headers: {authorization: `bearer ${token}`}

        })
          .then(() => {
            this.$store.dispatch('setGenericModalText', 'Adres e-mail został pomyślnie zmieniony.');

            this.$store.dispatch('setModalType', 'genericModal');
            if (sessionStorage.getItem('user')) JSON.parse(sessionStorage.getItem('user')).email = this.newEmail;
            if (localStorage.getItem('user')) JSON.parse(localStorage.getItem('user')).email = this.newEmail

          })
          .catch(function(error) {
            handleError(error.response);
          });
        this.invalid = false;
      }
    }
  },
  watch: {
    content() {
      this.showErrorInfo = null;
      this.invalid = false;

    },
    oldPassword() {
      this.showErrorInfo = null;
      this.invalid = false;

    },
    newPassword() {
      this.showErrorInfo = null;
      this.invalid = false;

    },
    repeatPassword() {
      this.showErrorInfo = null;
      this.invalid = false;

    },
    newEmail() {
      this.showErrorInfo = null;
      this.invalid = false;

    },
    repeatEmail() {
      this.showErrorInfo = null;
      this.invalid = false;

    },

  },

  
  mounted() {}
}
